<template>
  <div v-loading="loading" class="dashboard-editor-container">
    <el-card shadow="never">
      <div slot="header" style="font-size: 18px; font-weight: 700">统计</div>
      <div class="cards">
        <el-card v-if="showMember || isSuperAdmin" shadow="never" class="card" @click.native="nav('/member/member')">
          <div slot="header" class="title">用户注册</div>
          <span class="number">{{ count[0] || 0 }}</span>
        </el-card>
        <el-card v-if="showCompanyAccount || isSuperAdmin" shadow="never" class="card" @click.native="nav('/company/companyAccount')">
          <div slot="header" class="title">企业注册</div>
          <span class="number">{{ count[1] || 0 }}</span>
        </el-card>
        <el-card v-if="showJob || isSuperAdmin" shadow="never" class="card" @click.native="nav('/company/jobManagement')">
          <div slot="header" class="title">已发布职位</div>
          <span class="number">{{ count[2] || 0 }}</span>
        </el-card>
        <el-card v-if="showMemberSendResumeRecord || isSuperAdmin" shadow="never" class="card" @click.native="nav('/member/resumeManagement')">
          <div slot="header" class="title">投递简历记录</div>
          <span class="number">{{ count[3] || 0 }}</span>
        </el-card>
      </div>
    </el-card>

    <el-card shadow="never">
      <div slot="header" style="font-size: 18px; font-weight: 700">系统</div>

      <div v-if="showSystemConfig || isSuperAdmin" style="padding: 0 25px; width: max-content; line-height: 40px; border-radius: 8px; background-color: #e6e9ee; font-weight: 700; cursor: pointer" @click="nav('/setting/globalVars')">
        全局变量配置
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import checkPermission from '@/utils/permission' // 全局权限控制
export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      loading: true,
      count: [0, 0, 0, 0]
    }
  },
  computed: {
    ...mapGetters(['permissions', 'roles']),
    showMember() {
      return this.roles.indexOf('admin:member') > -1
    },
    showCompanyAccount() {
      return this.roles.indexOf('admin:companyAccount') > -1
    },
    showJob() {
      return this.roles.indexOf('admin:job') > -1
    },
    showMemberSendResumeRecord() {
      return this.roles.indexOf('admin:memberSendResumeRecord') > -1
    },
    showSystemConfig() {
      return this.roles.indexOf('admin:systemConfig2') > -1
    },
    isSuperAdmin() {
      return this.roles.indexOf('admin:*') > -1
    }
  },
  created() {
    console.log(this.roles, 'roles')
    this.showMember
    const { reqMemberCount, reqCompanyAccountCount, reqJobCount, reqSendResumeCount } = this.$api.dashboard
    Promise.all([reqMemberCount(), reqCompanyAccountCount(), reqJobCount(), reqSendResumeCount()])
      .then((res) => {
        this.count = res
      })
      .catch((e) => {}).finally(e => {
        this.loading = false
      })
  },
  methods: {
    checkPermission,
    nav(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  background-color: #f0f2f5;
  position: relative;
  box-sizing: border-box;
  height: calc(100vh - 84px);
  padding: 20px;
  &::v-deep .el-card {
    background-color: transparent !important;
    border: none;
  }
  &::v-deep .el-card__header {
    border: none;
  }
  .cards {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    &::v-deep .el-card {
      background-color: #e6e9ee !important;
    }
    &::v-deep .el-card__header {
      border: none;
      padding: 10px;
    }
    .card {
      cursor: pointer;
      margin: 0 20px 20px 0;
      border-radius: 16px;
      height: 120px;
      width: 180px;
      position: relative;
      box-sizing: border-box;
      .title {
        color: #7a8ca9;
        font-size: 16px;
      }
      .number {
        color: #536480;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 30px;
      }
    }
  }
}
</style>
